import * as Hooks from 'preact/hooks';
import { AppControlContext } from '../context/appControl';

/**
 * Hook to wrap using the app context.
 * If the app control context has not yet loaded, does nothing.
 *
 * Avoids the need to figure out if appControl is undefined or not
 */
export const useAppControl = () => {
    const appControl = Hooks.useContext(AppControlContext);

    const closeApp = Hooks.useMemo(() => () => appControl?.closeApp(), [appControl]);
    const enhanceCloseApp = Hooks.useMemo(
        () => (key: string, action: () => void) => appControl?.enhanceCloseApp(key, action),
        [appControl],
    );

    // memoise building to avoid endless change cycles based on new object construction
    const appControlInterface = Hooks.useMemo(
        () => ({ closeApp, enhanceCloseApp }),
        [closeApp, enhanceCloseApp],
    );

    return appControlInterface;
};
